module.exports = __webpack_public_path__ + "images/bug_light_blue_size_5_92108d0124cf64298e7926be784b1d8e.png";